// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"734":"8d9f261c","922":"b0eac2fa"}[chunkId] + ".chunk.css";
};